import { _HasDataLoaderMeta } from 'unplugin-vue-router/runtime'

export const routes = [
  {
    path: '/',
    name: 'Root',
    component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/index.vue'),
    /* no children */
    meta: {
      "layout": "navbar-layout"
    }
  },
  {
    path: '/cti',
    /* internal name: 'Cti' */
    /* no component */
    children: [
      {
        path: 'dashboard',
        name: 'CtiDashboard',
        component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/cti/dashboard.vue'),
        /* no children */
      },
      {
        path: 'ioc-feeds',
        name: 'CtiIocFeeds',
        component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/cti/ioc-feeds.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/drps',
    /* internal name: 'Drps' */
    /* no component */
    children: [
      {
        path: 'drps-dashboard',
        name: 'DrpsDashboard',
        component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/drps/drps-dashboard.vue'),
        /* no children */
        meta: {
          "layout": "navbar-layout"
        }
      },
      {
        path: 'incident-management',
        name: 'IncidentManagement',
        component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/drps/incident-management.vue'),
        /* no children */
        meta: {
          "layout": "navbar-layout"
        }
      },
      {
        path: 'incident-management-baseline',
        name: 'IncidentManagementBaseline',
        component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/drps/incident-management-baseline.vue'),
        /* no children */
        meta: {
          "layout": "navbar-layout"
        }
      }
    ],
  },
  {
    path: '/easm',
    /* internal name: 'Easm' */
    /* no component */
    children: [
      {
        path: 'threat-intelligence',
        name: 'ThreatIntelligence',
        component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/easm/threat-intelligence.vue'),
        /* no children */
        meta: {
          "layout": "navbar-layout"
        }
      }
    ],
  },
  {
    path: '/platform',
    /* internal name: 'Platform' */
    /* no component */
    children: [
      {
        path: 'alerts',
        name: 'Alerts',
        component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/platform/alerts.vue'),
        /* no children */
        meta: {
          "layout": "navbar-layout"
        }
      },
      {
        path: 'asset-inventory',
        name: 'AssetInventory',
        component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/platform/asset-inventory.vue'),
        /* no children */
        meta: {
          "layout": "navbar-layout"
        }
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/platform/dashboard.vue'),
        /* no children */
        meta: {
          "layout": "navbar-layout"
        }
      },
      {
        path: 'user-statistics',
        name: 'UserStatistics',
        component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/platform/user-statistics.vue'),
        /* no children */
        meta: {
          "layout": "navbar-layout"
        }
      },
      {
        path: 'users',
        /* internal name: 'PlatformUsers' */
        /* no component */
        children: [
          {
            path: ':id',
            name: 'UserDetail',
            component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/platform/users/[id].vue'),
            /* no children */
            meta: {
              "layout": "navbar-layout"
            }
          }
        ],
      },
      {
        path: 'vuln-intel',
        name: 'VulnIntel',
        component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/platform/vuln-intel.vue'),
        /* no children */
        meta: {
          "layout": "navbar-layout"
        }
      }
    ],
  },
  {
    path: '/reference',
    /* internal name: 'Reference' */
    /* no component */
    children: [
      {
        path: 'cards-table',
        name: 'ReferenceCardsTable',
        component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/reference/cards-table.vue'),
        /* no children */
      },
      {
        path: 'dashboard-grid',
        name: 'ReferenceDashboardGrid',
        component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/reference/dashboard-grid.vue'),
        /* no children */
      },
      {
        path: 'detail-tabs',
        name: 'ReferenceDetailTabs',
        component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/reference/detail-tabs.vue'),
        /* no children */
      },
      {
        path: 'sidebar-layout',
        name: 'ReferenceSidebarLayout',
        component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/reference/sidebar-layout.vue'),
        children: [
          {
            path: 'domain',
            name: 'ReferenceSidebarLayoutDomain',
            component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/reference/sidebar-layout/domain.vue'),
            /* no children */
          },
          {
            path: 'findings',
            name: 'ReferenceSidebarLayoutFindings',
            component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/reference/sidebar-layout/findings.vue'),
            /* no children */
          },
          {
            path: 'ip',
            name: 'ReferenceSidebarLayoutIp',
            component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/reference/sidebar-layout/ip.vue'),
            /* no children */
          },
          {
            path: 'scan-history',
            name: 'ReferenceSidebarLayoutScanHistory',
            component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/reference/sidebar-layout/scan-history.vue'),
            /* no children */
          },
          {
            path: 'ssl',
            name: 'ReferenceSidebarLayoutSsl',
            component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/reference/sidebar-layout/ssl.vue'),
            /* no children */
          },
          {
            path: 'website',
            name: 'ReferenceSidebarLayoutWebsite',
            component: () => import('/builds/developer-core-team/brandefense-prototype/src/pages/reference/sidebar-layout/website.vue'),
            /* no children */
          }
        ],
      }
    ],
  }
]
